import React from 'react';
import { Phone } from 'lucide-react';

const ContactFloatingButtons = () => {
  const phoneNumber = '+917080100324'; 
  const whatsappNumber = '917080100324'; 
  const displayNumber = '+91 70801 00324';

  const whatsappText =
   'Hi, I want details about admission in BNS Mahila Mahavidyalaya. Please share complete information.';

  const openWhatsApp = () => {
    const appUrl = `whatsapp://send?phone=${whatsappNumber}&text=${encodeURIComponent(
      whatsappText
    )}`;

    const webUrl = `https://api.whatsapp.com/send?phone=${whatsappNumber}&text=${encodeURIComponent(
      whatsappText
    )}`;

    window.location.href = appUrl;

    setTimeout(() => {
      window.location.href = webUrl;
    }, 1500);
  };

  return (
    <>
      {/* CALL BUTTON - LEFT */}
      <div className="fixed bottom-6 left-6 z-50">
        <div className="relative group">
          <a
            href={`tel:${phoneNumber}`}
            className="flex items-center justify-center w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-700 text-white rounded-full shadow-lg transition-all duration-300 hover:scale-110 hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-blue-400"
          >
            <Phone className="w-6 h-6" />
          </a>

          <div className="absolute left-full ml-3 top-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-all duration-300 pointer-events-none bg-gray-800 text-white text-xs rounded-lg px-3 py-1.5 whitespace-nowrap shadow-lg">
            Call: {displayNumber}
          </div>
        </div>
      </div>

      {/* WHATSAPP BUTTON - RIGHT */}
      <div className="fixed bottom-6 right-6 z-50">
        <div className="relative group">
          <button
            type="button"
            onClick={openWhatsApp}
            className="flex items-center justify-center w-12 h-12 bg-gradient-to-br from-[#25D366] to-[#128C7E] text-white rounded-full shadow-lg transition-all duration-300 hover:scale-110 hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-[#25D366]"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="w-6 h-6"
            >
              <path d="M12.032 2.001c-5.514 0-10 4.486-10 10 0 1.787.472 3.531 1.361 5.058l-1.391 4.5 4.656-1.29a9.966 9.966 0 0 0 5.374 1.532c5.514 0 10-4.486 10-10s-4.486-10-10-10zm0 18.2c-1.702 0-3.34-.468-4.758-1.35l-.336-.2-2.92.81.86-2.858-.214-.34a8.034 8.034 0 0 1-1.352-4.462c0-4.427 3.603-8.03 8.03-8.03s8.03 3.603 8.03 8.03-3.603 8.03-8.03 8.03zm4.465-5.707c-.245-.123-1.45-.717-1.674-.799-.224-.082-.387-.123-.55.123-.163.246-.632.799-.775.963-.143.164-.286.185-.53.062-.245-.123-1.034-.38-1.968-1.215-.727-.65-1.218-1.452-1.362-1.697-.143-.245-.015-.377.108-.5.11-.11.245-.287.368-.43.122-.144.163-.246.245-.41.082-.164.041-.307-.02-.43-.062-.123-.55-1.324-.754-1.813-.199-.478-.4-.41-.55-.41-.143 0-.306-.02-.47-.02-.163 0-.43.062-.654.307-.224.246-.86.84-.86 2.05 0 1.21.88 2.38 1.002 2.55.123.164 1.73 2.65 4.19 3.71.586.25 1.043.4 1.4.512.588.19 1.122.163 1.545.099.47-.073 1.45-.593 1.654-1.166.204-.573.204-1.064.143-1.166-.061-.102-.224-.164-.47-.287z" />
            </svg>
          </button>

          <div className="absolute right-full mr-3 top-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-all duration-300 pointer-events-none bg-gray-800 text-white text-xs rounded-lg px-3 py-1.5 whitespace-nowrap shadow-lg">
            WhatsApp: {displayNumber}
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactFloatingButtons;